import localStorage from '@/storage/local-storage'

const pageView = (baseTrackingData) => ({
  ranking: {
    ...baseTrackingData,
    source: localStorage.getSource(),
  },
  event: 'rankingRendered',
})

export default pageView
